import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'

import Layout from 'components/layout'
import SEO from 'components/seo'
import ResourcesFilter from 'sections/Resources/ResourcesFilter'
import Partners from 'sections/Home/Partners'
import ArticleList from 'sections/Resources/ArticleList'

const ResourcesPage = ({ data, location }) => {
  const unfilteredArticles = data.allContentfulArticle.nodes
  const [type, setType] = useState('')
  const [search, setSearch] = useState('')
  const [category, setCategory] = useState('')
  const [articles, setArticles] = useState(data.allContentfulArticle.nodes)
  const [supportSelected, setSupportSelected] = useState(false)

  function filterArticles(article) {
    const isSameType = article.type === type
    const matchesSearch = [
      article.content.raw,
      article.tags?.join(' '),
      article.title,
      article.author,
    ]
      .join(' ')
      .toLowerCase()
      .includes(search.toLowerCase())
    const isSameCategory = article.category.split('-')[0] === category
    if (type && search && category) {
      return isSameType && matchesSearch && isSameCategory
    }
    if (type && search) {
      return isSameType && matchesSearch
    }
    if (type && category) {
      return isSameType && isSameCategory
    }
    if (type) {
      return isSameType
    }
    if (search) {
      return matchesSearch
    }
    return true
  }

  useEffect(() => {
    const newArticles = [...unfilteredArticles].filter(filterArticles)
    const newArticlesSorted = newArticles.sort(
      (a, b) => Date.parse(b.publishedDate) - Date.parse(a.publishedDate)
    )
    setArticles(newArticlesSorted)
  }, [type, search, category])

  useEffect(() => {
    if (location.state?.type) {
      setType(location.state.type)
      if (location.state?.category) {
        setCategory(location.state.category)
      }
    }
  }, [location])

  return (
    <Layout>
      <SEO title="Resources" />
      {/* <ResourcesFilter
        data={data}
        search={search}
        setSearch={setSearch}
        articles={articles}
        setType={setType}
        type={type}
        supportSelected={supportSelected}
        setSupportSelected={setSupportSelected}
      /> */}
      <ArticleList
        type={type}
        setType={setType}
        articles={articles}
        category={category}
        setCategory={setCategory}
        allArticles={unfilteredArticles}
        supportSelected={supportSelected}
      />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    allContentfulArticle(filter: { title: { nin: "DUMMY DO NOT DELETE" } }) {
      nodes {
        tags
        title
        author {
          name
          photo {
            file {
              url
            }
          }
        }
        category
        type
        publishedDate
        coverImage {
          file {
            url
          }
        }
        content {
          raw
          references {
            ... on ContentfulAsset {
              file {
                url
              }
              id
            }
          }
        }
      }
    }
    resources: file(relativePath: { eq: "resources.jpg" }) {
      ...fluidImage
    }
  }
`

export default ResourcesPage
